var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 96,
    viewBox: "0 0 118 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9166 50.5775C69.3621 26.8895 75.726 8.50468 75.726 8.50468L100.121 3.90848C90.2217 26.5359 79.2616 39.6174 60.8768 61.5377C42.492 83.458 24.8144 94.0646 24.8144 94.0646L12.0864 81.3367C12.0864 81.3367 30.4712 74.2656 49.9166 50.5775Z",
    fill: "#DC4649",
    stroke: "#DC4649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5343 42.8842C80.2224 62.3296 98.6071 68.6936 98.6071 68.6936L103.203 93.0888C80.5759 83.1893 67.4944 72.2291 45.5741 53.8443C23.6538 35.4596 13.0472 17.7819 13.0472 17.7819L25.7751 5.05396C25.7751 5.05396 32.8462 23.4387 56.5343 42.8842Z",
    fill: "#DC4649",
    stroke: "#DC4649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.04c9791ae3d6ccf007387d391e045dd5.svg";
export { ForwardRef as ReactComponent };